<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    百分比：
                    <el-select style="width: 100px" v-model="coefficient">
                        <el-option
                                v-for="item of coefficientOptions"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-input
                            placeholder="输入用户ID或昵称查询"
                            v-model="searchVal">
                        <el-select style="width: 120px" v-model="select" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" value="userRandomId"></el-option>
                            <el-option label="用户昵称" value="nickname"></el-option>
                        </el-select>
                    </el-input>
                </div>

                <div class="common-header-block">
                    <el-input v-model="clubRandomId" placeholder="请输入俱乐部ID">
                        <template slot="prepend">俱乐部ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="searchUserStats()">搜索</el-button>
                    <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>

        <div>
            <strong class="common-text-item" v-text="`总带入：${userStats.totalBring/100}`"></strong>
            <strong class="common-text-item" v-text="`总保险：${userStats.totalInsurance/100}`"></strong>
            <strong class="common-text-item" v-text="`总盈亏：${userStats.totalIntegral/100}`"></strong>
            <strong class="common-text-item" v-text="`总手数：${userStats.totalHands}`"></strong>
            <strong class="common-text-item" v-text="`总数累计值：${userStats.coefficientSum}`"></strong>
        </div>

        <div>
            <strong class="common-text-item" v-text="`充值成功：${userStats.topupSum}`"></strong>
            <strong class="common-text-item" v-text="`提现成功：${userStats.withdrawSum}`"></strong>
        </div>

        <div style="line-height: 60px;">
            <strong style="    margin-right: 25px;">
                用户层级:
                <template>
                    <!--T名单-->
                    <template v-if="userStats.level === 6">{{userLevelArr[userStats.level]}}</template>
                    <select-set-value
                            v-else
                            class="select-set-value"
                            :list="userLevelOptions"
                            :text="userScoreAndLevel[`${userStats.score},${userStats.level}`]"
                            @my-submit="updateLevelFunc($event,userStats.userId)"/>
                </template>
            </strong>
            <strong>
                层级来源:
                <span v-text="userStats.isAuto?'自动':userStats.isAuto===''?'':'手动'"></span>
            </strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userStats.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="俱乐部号" align="center" prop="clubRandomId"/>
                <el-table-column label="俱乐部名称" width="150" align="center" prop="clubName"/>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="房间ID" width="120" align="center" prop="roomId"/>
                <el-table-column label="房间名称" align="center" prop="roomName"/>
                <el-table-column label="保险池" align="center" prop="insurancePool">
                  <template slot-scope="scope">{{scope.row.insurancePool|numberChip}}</template>
                </el-table-column>
                <el-table-column label="总带入" align="center" prop="totalBring">
                  <template slot-scope="scope">{{scope.row.totalBring|numberChip}}</template>
                </el-table-column>
                <el-table-column label="手数" align="center" prop="totalHands"/>
                <el-table-column label="盈亏" align="center" prop="integral">
                  <template slot-scope="scope">{{scope.row.integral|numberChip}}</template>
                </el-table-column>
                <el-table-column label="大小盲" align="center" prop="blind">
                  <template slot-scope="scope">{{scope.row.blind|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="结束时间" width="150" align="center" prop="endTime"/>
                <el-table-column label="注册时间" width="150" align="center" prop="regTime"/>
                <!-- <el-table-column label="是否开启保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.insurance?'是':'否'}}</template>
                </el-table-column> -->
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="userStats.total"
                :current-page="currentPage"
                @current-change="searchUserStats({page:$event})"/>
    </div>
</template>
<script>
    import {mapState,mapGetters,mapMutations, mapActions} from 'vuex'
    import selectSetValue from 'components/selectSetValue'
    export default {
        data() {
            return {
                loading: false,
                date: null,
                select: 'userRandomId',// 用户id或者昵称
                searchVal: null,
                clubRandomId: '',// 俱乐部随机id
                userLevelScores: [],
                coefficient: '1', // 百分比
                coefficientOptions: [
                    {label: '0%', value: '0'},
                    {label: '1%', value: '1'},
                    {label: '2%', value: '2'},
                    {label: '3%', value: '3'},
                    {label: '4%', value: '4'},
                    {label: '5%', value: '5'},
                    {label: '6%', value: '6'},
                    {label: '7%', value: '7'},
                    {label: '8%', value: '8'},
                    {label: '9%', value: '9'},
                    {label: '10%', value: '10'},
                ],
                userStats: {// 用户牌局信息
                    beanList: [],
                    total: 0,
                    totalBring: 0,// 总带入
                    totalInsurance: 0,// 总保险
                    totalIntegral: 0,// 总盈亏
                    totalHands: 0,// 总手数
                    coefficientSum: 0,// 总数累计值
                    topupSum:0,//总充值成功
                    withdrawSum:0,//提现成功
                    level:'',
                    score:'',
                    userId:'',
                    isAuto:''

                },
                currentPage:1
            }
        },
        components:{
            selectSetValue
        },
        computed: {
            ...mapState('login', ['permissions']),
            ...mapGetters('user', ['userLevelArr', 'userScoreAndLevel', 'userLevelOptions', 'userLabelOptions']),
        },
        created() {
            this.getUserLevelConfigList();
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getUserStats']),
            ...mapActions('user', ['getUserLevelConfigList', 'getUserLabelList', 'setUserAddLabel']),
            ...mapActions('userOnline', ['updateUserLevel']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.searchVal) {
                    this.$message.error('请输入用户ID或昵称');
                    return false
                }
                return true
            },
            updateLevelFunc({value, cb}, userId) {
                this.updateUserLevel({
                    level: value.split(',')[1],
                    score: value.split(',')[0],
                    userId
                }).then(() => {
                    cb();
                    this.$message.success('修改成功');
                    this.searchUserStats();
                })
            },
            searchUserStats(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    [this.select]: this.searchVal,
                    clubRandomId: this.clubRandomId,
                    coefficient: this.coefficient,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getUserStats(params).then(res => {
                    this.userStats = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/gameDetail/user/stats/export',
                    info: [
                        {name: this.select, value: this.searchVal},
                        {name: 'clubRandomId', value: this.clubRandomId},
                        {name: 'coefficient', value: this.coefficient},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]}
                    ]
                })
            }
        }
    }
</script>